module.exports = __webpack_public_path__ + "img/009-avatar-7.44e89b01.png";